<template>
    <div class="payment-list grid grid__base">
        <div class="payment-list--container grid--container">
            <div class="payment-list--row payment-list--header-row grid--row">
                <div class="payment-list--title-col grid--col">
                    <slot name="title"/>
                </div>
                <div class="payment-list--filter-col grid--col">
                    <form-field-select class="payment-list--filter"
                            :facets="['base', 'secondary-select']"
                            :items="transformedOptions"
                            v-model="selectedFilter"
                    />
                </div>
            </div>

            <ul class="u-reset payment-list--list grid--row">
                <li class="payment-list--item grid--col"
                        v-for="(item, idx) in filteredListItems"
                        :key="item.hash_id">
                    <payment-method
                            class="payment-list--method"
                            :next-item="getNextItem(idx)"
                            :item-id="item.hash_id"
                            :facets="[ disableOverlays ? null : 'clickable']"
                            :overlay-disabled="disableOverlays"
                            v-bind="item"
                            @registered="onOverlayRegistered"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { reduce } from 'lodash';

    import PaymentMethod from 'framework/global-components/dyn/payment-method/payment-method';
    import FormFieldSelect from 'framework/global-components/dyn/form/form-field-select/form-field-select';

    export default {
        components: {
            FormFieldSelect,
            PaymentMethod,
        },

        props: {
            /**
             * @type {IFilterOption}
             */
            filterOptions: {
                type: Array,
                required: true,
            },

            placeholder: {
                type: String,
                default: null,
            },

            /**
             * @type {IPaymentMethodListItem[]}
             */
            items: {
                type: Array,
                required: true,
            },

            disableOverlays: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                selectedFilter: '',
                registeredOverlays: {},
            };
        },

        computed: {

            transformedOptions() {
                return this.filterOptions.map((option) => {
                    return {
                        val: option.value,
                        label: option.label,
                    };
                });
            },

            /**
             * Get list of filtered items
             * @return {IPaymentMethodListItem[]}
             */
            filteredListItems() {
                if (!this.selectedFilter) {
                    return this.items;
                }


                return reduce(this.items, (acc, item) => {
                    if (this.selectedFilter === item.category_slug || !this.selectedFilter) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
            },
        },

        methods: {
            ...mapActions('overlay', ['openOverlay', 'registerOverlay']),
            ...mapActions('payment-methods', ['setItems', 'setItemOverlayRef']),

            getNextItem(idx) {
                const nextItem = this.items[idx + 1];
                if (!nextItem) {
                    return null;
                }
                return nextItem;
            },

            onOverlayRegistered({ hash, overlayId }) {
                this.registeredOverlays[hash] = overlayId;
                this.setItemOverlayRef({ hash, overlayId });
            },
        },

        watch: {
            filteredListItems(items) {
                this.setItems({ items });
            },
        },

        mounted() {
            this.setItems({ items: this.items });
        },
    };
</script>
